export default __webpack_public_path__ + "static/rsoc-09dd6049e7a6cc8e4fc1d911628d5dc7.png";